<div class="sidebar-container">
  <div class="project-info-container">
  <div class="project-info" *ngIf="selectedProject">
    <div class="project-header">
      <div class="back-button" (click)="backToProjects()">
        <i class="back-icon"></i>
        Back to Projects
      </div>
    </div>
  </div>

  <aside class="sidebar" [class.sidebar-collapsed]="isSidebarCollapsed">
    <!-- Collapse/Expand Button -->
    <button class="collapse-btn" (click)="toggleSidebarCollapse()" *ngIf="isMobileView">
      <i [ngClass]="isSidebarCollapsed ? 'bi bi-chevron-down' : 'bi bi-chevron-up'"></i>
    </button>

    <div class="project-info">
      <h3>{{ selectedProject?.title }}</h3>
    </div>

    <!-- Toggle Button -->
    <div class="container-fluid  d-flex h-20 flex-wrap align-items-center">
      <button class="btn btn-outline rounded-circle  border-0" (click)="toggleSidebar()"  ngbTooltip="Show/Hide Filter">
        <i class="ml-2" [ngClass]="showSidebar ? 'bi bi-funnel-fill' : 'bi bi-funnel'"></i>
      </button>
      <div class="filter-alert col-md-6 text-left"   *ngIf="isFilterActive()" >
        <span class="text-warning">Filters Are Active</span>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="filters-container" *ngIf="showSidebar">
      <div class="search-section">
        <div class="search-input-wrapper">
          <i class="search-icon"></i>
          <input
            type="text"
            placeholder="Search topics..."
            [ngModel]="searchText"
            (ngModelChange)="onSearchInput($event)"
            class="search-input"
          />
        </div>
      </div>

      <div class="filters-section">
        <div class="filter-group">
          <select [(ngModel)]="selectedStatus" (ngModelChange)="applyFilters()" class="filter-dropdown">
            <option value="all">All statuses</option>
            <option value="NEW">New</option>
            <option value="ADMIN_REVIEW">Admin Review</option>
            <option value="SENT_TO_CUSTOMER">Sent to Customer</option>
            <option value="RESOLVED">Resolved</option>
          </select>
        </div>

        <div class="filter-group">
          <select [(ngModel)]="sortOrder" (ngModelChange)="applyFilters()" class="filter-dropdown">
            <option value="newest">Newest</option>
            <option value="oldest">Oldest</option>
          </select>
        </div>
      </div>

      <button
        class="btn btn-secondary clear-filters"
        (click)="clearFilters()"
        [disabled]="!hasActiveFilters()">
        Clear Filters
      </button>
    </div>
    <button class="button-new-topic" (click)="creatingTopic = true" *ngIf="!creatingTopic" ngbTooltip="Create a new topic">+ New Topic</button>

    <div *ngIf="creatingTopic">
      <input [(ngModel)]="newTopicTitle"
            placeholder="Enter new topic title"
            class="new-topic-input"
            [ngClass]="{'error': hasNewTopicCyrillicError}"
            (keyup)="checkNewTopicCyrillic()"/>
      <div class="error-message" *ngIf="hasNewTopicCyrillicError">
        {{ cyrillicErrorMessage }}
      </div>
      <button class="btn btn-primary" (click)="createNewTopic()">Create</button>
      <button class="btn btn-secondary" (click)="creatingTopic = false">Cancel</button>
    </div>

    <ul>
      <li *ngIf="filteredTopics.length === 0" class="no-topics-message">
        There are no topics in this project yet
      </li>
      <li *ngFor="let topic of filteredTopics"
          (click)="selectTopic(topic)"
          [class.selected]="selectedTopic?.id === topic.id">
        <div class="topic-info">
          <span class="topic-title">{{ topic.title }}</span>
          <div class="unread-badge" *ngIf="unreadMessagesCountByTopic[topic.id]">
            {{ unreadMessagesCountByTopic[topic.id] }}
          </div>
          <div class="topic-status" [ngClass]="{
            'new': topic.status === 'NEW',
            'admin-review': topic.status === 'ADMIN_REVIEW',
            'sent-to-customer': topic.status === 'SENT_TO_CUSTOMER',
            'resolved': topic.status === 'RESOLVED'
          }">
            <i class="status-icon"></i>
            <span class="status-text">{{ topic.status }}</span>
          </div>
        </div>
        <div class="topic-meta" *ngIf="topic.lastUpdated">
          {{ topic.lastUpdated | date:'short' }}
        </div>
      </li>
    </ul>
  </aside>
</div>
</div>
